// extracted by mini-css-extract-plugin
export default {"base":"vp_Ude3V","drawerPane":"vp_XPmQD","mainPane":"vp_OQLOE","headerBlock":"vp_UQ1o1","pinned":"vp_U3nPP","contentBlock":"vp_HVRfw"};